export default __webpack_public_path__ + "static/media/empty-data.a969061e.svg";